import React from 'react';
// Images
import DividerImage from '../../assets/images/pages/path1.png';

function PageDivider() {
  return (
    <div className='py-4 sm:py-5 lg:hidden'>
      <img src={DividerImage} alt='Divider' className='' />
    </div>
  );
}

export default PageDivider;
